import { Bounds } from "../../../utilities/BoundsObserver/Bounds";

/**
 * The default bounds.
 */
const DefaultBounds: Bounds = { top: 0, left: 0, width: 0, height: 0 };

/**
 * Updates the bounds of the specified element.
 * @param element The element to update the bounds for.
 * @param bounds The bounds.
 * @param previousBounds The previous bounds.
 */
export function updateOverlayBounds(element: HTMLDivElement, bounds: Bounds, previousBounds: Bounds | null): void {
  const { top, left, width, height } = bounds;
  const { top: previousTop, left: previousLeft, width: previousWidth, height: previousHeight } = previousBounds ?? DefaultBounds;

  if (top !== previousTop || left !== previousLeft)
    element.style["transform"] = `translate(${left}px, ${top}px)`;

  if (width !== previousWidth)
    element.style["width"] = `${width}px`;

  if (height !== previousHeight) {
    // Only set explicit height if non-zero, otherwise let content determine height
    element.style["height"] = height > 0 ? `${height}px` : "";
  }
}
